import { createSlice, type Draft } from '@reduxjs/toolkit';

import type { SentencaArbitralDados } from '../../types/sentencaArbitral.types';
import { fetchSentencaArbitral, SENTENCA_NAO_PUBLICADA, SENTENCA_SEM_PERMISSAO } from './actions';

interface SentencaArbitralState {
  sentenca: SentencaArbitralDados | null;
  loading: boolean;
  error: string | null;
  semPermissao: boolean;
  naoPublicada: boolean;
  requestId: string | null;
}

const initialState: SentencaArbitralState = {
  sentenca: null,
  loading: false,
  error: null,
  semPermissao: false,
  naoPublicada: false,
  requestId: null,
};

const sentencaArbitralSlice = createSlice({
  name: 'sentencaArbitral',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSentencaArbitral.pending, (state, action) => {
        state.requestId = action.meta.requestId;
        state.loading = true;
        state.error = null;
        state.semPermissao = false;
        state.naoPublicada = false;
        state.sentenca = null;
      })
      .addCase(fetchSentencaArbitral.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        state.sentenca = action.payload as Draft<SentencaArbitralDados>;
      })
      .addCase(fetchSentencaArbitral.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        if (action.payload === SENTENCA_SEM_PERMISSAO) {
          state.semPermissao = true;
          return;
        }
        if (action.payload === SENTENCA_NAO_PUBLICADA) {
          state.naoPublicada = true;
          return;
        }
        state.error = action.payload || 'Erro ao carregar o documento da sentença';
      });
  },
});

export const sentencaArbitralReducer = sentencaArbitralSlice.reducer;
